import dagre from "dagre";

// Function to layout nodes and edges with conditional direction
const getLayoutedElements = (nodes, edges, nodeRefs) => {
  const dagreGraphLR = new dagre.graphlib.Graph();
  const dagreGraphTB = new dagre.graphlib.Graph();
  const graphSettings = {
    nodesep: 100,
    ranksep: 100,
    edgeLabelSpace: true, // Ensures edges don’t interfere with nodes
  };

  dagreGraphLR.setGraph({ rankdir: "LR", ...graphSettings });
  dagreGraphTB.setGraph({ rankdir: "TB", ...graphSettings, ranksep: 180 });

  dagreGraphLR.setDefaultEdgeLabel(() => ({}));
  dagreGraphTB.setDefaultEdgeLabel(() => ({}));

  // Add nodes to graphs only once
  nodes.forEach((node) => {
    const element = nodeRefs?.current[node.id];
    const newWidth = element?.offsetWidth;
    const newHeight = element?.offsetHeight;

    dagreGraphLR.setNode(node.id, {
      width: element ? newWidth : 350,
      height: element ? newHeight : 350,
    });
    dagreGraphTB.setNode(node.id, {
      width: element ? newWidth : 350,
      height: element ? newHeight : 350,
    });
  });

  // Add edges to graphs based on type
  edges.forEach((edge) => {
    if (edge.edgeType === "stepToStep") {
      dagreGraphLR.setEdge(edge.source, edge.target);
    } else {
      dagreGraphTB.setEdge(edge.source, edge.target);
    }
  });

  // Apply layouts
  dagre.layout(dagreGraphLR);
  dagre.layout(dagreGraphTB);

  // Layout nodes based on edge connections
  const layoutedNodes = nodes.map((node) => {
    const isStepToStep = edges.some(
      (edge) => edge.source === node.id && edge.edgeType === "stepToStep"
    );

    const dagreNode = isStepToStep
      ? dagreGraphLR.node(node.id)
      : dagreGraphTB.node(node.id);

    return {
      ...node,
      position: { x: dagreNode.x, y: dagreNode.y },
      sourcePosition: isStepToStep ? "right" : "bottom",
      targetPosition: isStepToStep ? "left" : "top",
    };
  });

  return { nodes: layoutedNodes, edges };
};

export default getLayoutedElements;
